import { Map, fromJS } from 'immutable';
import requestStatus from "../constants/requestStatus"



export const onGet     = state             => state.set('status', requestStatus.REQUEST_PENDING)
                                                   .set('error', Map())
export const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)
                                                   .set('data', fromJS(action.payload))
export const onError   = (state, action)   => state.set('status', requestStatus.REQUEST_ERROR)
                                                   .setIn(['error','message'], action.payload.errorMessage)


export const sendDataRequested =    state               => state.set('status', requestStatus.REQUEST_PENDING)

export const sendDataSuccess =      initState           => initState.set('status', requestStatus.REQUEST_SUCCESS)

export const sendDataError =        (state, action)     => state.setIn(['status'], requestStatus.REQUEST_ERROR)
                                                                .setIn(['error', 'message'], action.payload.errorMessage)
